import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, HostBinding, Input } from '@angular/core';
import { LayoutService } from '../../../services/layout.service';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Subscription, filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { RippleModule } from 'primeng/ripple';

@Component({
    selector: '[app-menu-item]',
    imports: [CommonModule, RouterModule, RippleModule],
    animations: [
        trigger('children', [
            state(
                'collapsed',
                style({
                    height: '0'
                })
            ),
            state(
                'expanded',
                style({
                    height: '*'
                })
            ),
            transition('collapsed <=> expanded', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    providers: [LayoutService],
    templateUrl: './menu-item.component.html',
    styleUrl: './menu-item.component.scss'
})
export class MenuItemComponent {
    @Input() item!: MenuItem;

    @Input() index!: number;

    @Input() @HostBinding('class.layout-root-menuitem') root!: boolean;

    @Input() parentKey!: string;

    active = false;

    menuSourceSubscription: Subscription;

    menuResetSubscription: Subscription;

    key: string = '';

    navigableDropdownRoutes: string[] = ['/home/materiali-categorie-classi/artigiani/scheda', '/home/materiali-categorie-classi/artigiani/edit'];

    isNavigableDropdown: boolean = false;

    constructor(
        public router: Router,
        private layoutService: LayoutService,

    ) {
        this.menuSourceSubscription = this.layoutService.menuSource$.subscribe((value) => {
            Promise.resolve(null).then(() => {
                if (value.routeEvent) {
                    this.active = value.key === this.key || value.key.startsWith(this.key + '-') ? true : false;
                } else {
                    if (value.key !== this.key && !value.key.startsWith(this.key + '-')) {
                        this.active = false;
                    }
                }
            });
        });

        this.menuResetSubscription = this.layoutService.resetSource$.subscribe(() => {
            this.active = false;
        });

        this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((params) => {
            if (this.item.routerLink) {
                this.updateActiveStateFromRoute();
            }
        });
    }

    ngOnInit() {
        this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);

        if (this.item.routerLink) {
            this.updateActiveStateFromRoute();
        }
    }

    updateActiveStateFromRoute() {
        this.isNavigableDropdown = false;
        let activeRoute = this.router.isActive(this.item.routerLink[0], { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' });

        if (activeRoute) {
            this.layoutService.onMenuStateChange({ key: this.key, routeEvent: true });
            this.navigableDropdownRoutes.forEach((route) => {
                if (this.router.url.includes(route)) {
                    this.isNavigableDropdown = true;
                }
            });
        }

        if (activeRoute && !this.active) {
            this.active = true;
        } else if (!activeRoute && this.active) {
            this.active = false;
        }
    }

    itemClick(event: Event) {
        // avoid processing disabled items

        if (this.item.items) {
            this.active = !this.active;
            if (this.item.disabled) {
                event.preventDefault();
                return;
            }
        }

        // execute command
        if (this.item.command) {
            this.item.command({ originalEvent: event, item: this.item });
        }

        if (this.item.routerLink) {
            this.router.navigate(this.item.routerLink);
        }

        this.layoutService.onMenuStateChange({ key: this.key });
    }

    get submenuAnimation() {
        return this.root ? 'expanded' : this.active ? 'expanded' : 'collapsed';
    }

    @HostBinding('class.active-menuitem')
    get activeClass() {
        return this.active && !this.root;
    }

    // isMenuItemVisible(permissionLvlName?: string): boolean {
    //     if (!permissionLvlName) {
    //         return true;
    //     }

    //     return this._permissionChecker.isGranted(permissionLvlName);
    // }

    ngOnDestroy() {
        if (this.menuSourceSubscription) {
            this.menuSourceSubscription.unsubscribe();
        }

        if (this.menuResetSubscription) {
            this.menuResetSubscription.unsubscribe();
        }
    }
}
